module.exports = __webpack_public_path__ + "img/termosAdesao.b72ae55e.svg";